import React, { useState } from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { BackButton } from '../../../shared/components/back-button'
import { websiteStyleSettingsItemLocoKeys } from './consts'
import { WebsiteStylesSettingsTypeEnum } from './types'
import { WebsiteStylesSettingsButtonsAndLinks } from './website-styles-settings-buttons-and-links'
import { WebsiteStylesSettingsFormFields } from './website-styles-settings-form-fields'
import { WebsiteStylesSettingsLayout } from './website-styles-settings-layout'
import { WebsiteStylesSettingsList } from './website-styles-settings-list'
import { WebsiteStylesSettingsThemesAndColors } from './website-styles-settings-themes-and-colors'
import { WebsiteStylesSettingsTypography } from './website-styles-settings-typography'

export const WebsiteStylesSettings = () => {
  const { t } = useTypedTranslation()

  const [selectedItem, setSelectedItem] =
    useState<WebsiteStylesSettingsTypeEnum | null>(null)

  const renderSelectedItem = (selectedItem: WebsiteStylesSettingsTypeEnum) => {
    switch (selectedItem) {
      case WebsiteStylesSettingsTypeEnum.Typography:
        return <WebsiteStylesSettingsTypography />
      case WebsiteStylesSettingsTypeEnum.ThemesAndColors:
        return <WebsiteStylesSettingsThemesAndColors />
      case WebsiteStylesSettingsTypeEnum.ButtonsAndLinks:
        return <WebsiteStylesSettingsButtonsAndLinks />
      case WebsiteStylesSettingsTypeEnum.FormFields:
        return <WebsiteStylesSettingsFormFields />
      case WebsiteStylesSettingsTypeEnum.Layout:
        return <WebsiteStylesSettingsLayout />
    }
  }
  return (
    <>
      {!selectedItem ? (
        <WebsiteStylesSettingsList setItem={setSelectedItem} />
      ) : (
        <div>
          <BackButton className="mb-6!" onClick={() => setSelectedItem(null)} />
          <div className="mb-9 text-heading-4">
            {t(websiteStyleSettingsItemLocoKeys[selectedItem])}
          </div>
          {renderSelectedItem(selectedItem)}
        </div>
      )}
    </>
  )
}
